export default {
    newOrders: [],
    data: [],
    branches: [],
    addresses: [],
    drivers: [],
    statues: [],
    products: [],
    admins: [],
    orderTypes: [],
    vehicleTypes: [],
    cart: [],
    cancelReasons: [],
    deletedOrders:[],
    total: {
        totalItems: 5,
        totalPages: 5,
    },
    productDetail: {},

    detail: {
        driver: {
            id: 0
        },

    }

};
